import { render, staticRenderFns } from "./lab-order-column.vue?vue&type=template&id=3974d451&"
import script from "./lab-order-column.vue?vue&type=script&lang=js&"
export * from "./lab-order-column.vue?vue&type=script&lang=js&"
import style0 from "./lab-order-column.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports